import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, Label, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./Forms.css";
import Uploadform from "../../../assets/images/upload_form.svg";
import { formikAddPdfForm } from '../Constant';
import { createPdfForm, getApplicationType, getAllSigner } from '../../../api/workflow';
import { decryptData } from '../../../utils/helper';
import { failed, success } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import { handleFileUpload } from '../../../utils/ImageToBase64';
import MultiSelect from '../../../components/InputFields/MultiSelect';
import AddSignerModal from './AddSignerModal';
import { useGetStates } from '../../../hooks/useGetStates';
import { useDropzone } from 'react-dropzone';


const AddForm = ({setCurrentTab}) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [applicationList, setApplicationList] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const dispatch  = useDispatch();
    const { states } = useGetStates("US");
    const [statesList, setStateList] = useState([]);
    const [signerList, setsignerList] = useState([]);

    useEffect(() => {
        if (states && states.length > 0) {
            const formattedStates = states.map((obj) => ({
                label: obj.name,
                value: obj.name
            }));
            setStateList(formattedStates);
        }
    }, [states]);

    const formik = useFormik({
        ...formikAddPdfForm,
        onSubmit: async (values) => {
            let res;
            try {
                if(values.isSignatureReq){
                    if(values.signer.length === 0){
                        formik.setFieldError("signer", "Required field");
                        return;
                    }
                }else if(!values.pdfForm){
                    formik.setFieldError("pdfForm", "Required field");
                        return;
                }
                let base64pdfForm = "";
                if (values?.pdfForm.name !== undefined) {
                    base64pdfForm = await handleFileUpload(values?.pdfForm);
                    const fileExtension = values?.pdfForm?.type?.split("/")[1];
                    const pdfForm = {
                        base64String: base64pdfForm,
                        extension: fileExtension, // Add the file extension to the object
                        name: values?.pdfForm.name
                    };
                    values.pdfForm = pdfForm;
                }
                setIsLoading(true);
                res = await createPdfForm({ values, dispatch, token });
                if (res?.status == "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    formik.resetForm();
                    setCurrentTab("formList");
                    // navigate("/super-admin/o")
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const getSigners = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            res = await getAllSigner({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setsignerList(responseData.items);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };


      const getApplicationTypeList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getApplicationType({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setApplicationList(responseData?.items.filter((item)=> item?.isPublished !== false).map((obj)=> {
                    return {
                    label : obj?.applicationTitle,
                    value : obj?._id
                };}));
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
            setIsLoading(false);
        }
      };

    const handleState =(e)=>{
        formik.setFieldValue("stateId", e.target.value);
        formik.setFieldValue("state", statesList.find((obj)=> obj?.value === e.target.value));
    };

    useEffect(() => {
      getApplicationTypeList();
      getSigners();
    }, []);

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleRemoveFile = (index) => {
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);

        // Also clear Formik value
        if (index === 0) {
            formik.setFieldValue("pdfForm", null);
        }
    };


    const onDrop = (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            setSelectedFiles([file]);
            formik.setFieldValue("pdfForm", file); // ✅ Set file to Formik
        }
    };

   const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [] // ✅ Allow only PDF files
        },
        multiple: false // ✅ Only allow one file
    });

    return (
        <Fragment>
            {isLoading ? <Loader/> : null}
            {showModal ? <AddSignerModal refetch={getSigners} setShowModal={()=> setShowModal(!showModal)}/> : null}
            <div className="add_forms_workflow">
                <h6 className="block_name text-center mt-3">Upload PDF Form</h6>
                <Form onSubmit={formik.handleSubmit}>
                    <div className="first_block">
                        <Row>
                            <Col lg={6} className="location_block mb-3">
                                <TextInput
                                    keyField={"formTitle"}
                                    formik={formik}
                                    label="PDF Form Title"
                                    placeholder={"PDF Form Title"}
                                    type="text"
                                    value={formik.values.formTitle}
                                    onChange={(e) => formik.setFieldValue("formTitle", e.target.value)}
                                />
                            </Col>
                            <Col lg={6} className="location_block mb-3">
                                <MultiSelect
                                    keyField={"applicationTypeId"}
                                    multiple={false}
                                    formik={formik}
                                    label="Application Type"
                                    options={applicationList}
                                    placeholder="Application Type"
                                    value={formik.values.applicationTypeId}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} className="location_block mb-3">
                                <TextInput
                                    keyField={"stateId"}
                                    formik={formik}
                                    label="State"
                                    options={statesList}
                                    type="select"
                                    value={formik.values.stateId}
                                    onChange={(e) => handleState(e)}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-5'>
                            <Col lg={6}>
                             <Row>
                                <Label for="exampleFile"> Attachment <span style={{ color: "red" }}>*</span>
                                </Label>
                                <div {...getRootProps()} className="upload-area text-center">
                                    <input {...getInputProps()} />
                                    <img src={Uploadform} alt="upload" />
                                    <p>Drag & drop files here, or click to browse</p>
                                    <button type="button" className="browse_blk">Browse</button>
                                </div>
                                {formik?.errors["pdfForm"] && formik.touched["pdfForm"] && (
                                    <div style={{ color: "red" }}>{formik.errors["pdfForm"]}</div>
                                )}
                                </Row>
                                <Row className="mt-3" style={{ paddingTop: "100px" }}>
                                <Col md={6}>
                                    {selectedFiles.length > 0 && (
                                    <div className="uploaded-files mt-3">
                                        {selectedFiles.map((file, index) => (
                                        <div
                                            key={index}
                                            className="file-item d-flex justify-content-between align-items-center"
                                        >
                                            <p style={{ zIndex: "99" }}>{file.name}</p>
                                            <button type="button" className="cancel-btn" onClick={() => handleRemoveFile(index)}>
                                            <i className="fas fa-times" />
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                    )}
                                </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                <div className="d-flex gap-3 justify-content-center">
                    <button className="save_btn" type="submit">Save</button>
                    <button className="save_btn cancel_btn" onClick={()=> setCurrentTab("formList")}>Cancel</button>
                </div>
                </Form>
            </div>
        </Fragment>
    );
};

export default AddForm;

